import { render, staticRenderFns } from "./form-login-username.vue?vue&type=template&id=72a5eb4c"
import script from "./form-login-username.vue?vue&type=script&lang=js"
export * from "./form-login-username.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports